import styled from "styled-components";

export const EnvioWrapper = styled.div`
  .description_wrapper {
    width: 100%;
    display: flex;
    margin-top: -1rem;
    padding: 28px 0 0 30px;

    p {
      color: #000;
      font-size: 18px;
      font-weight: 400;
      line-height: 130%;
      font-style: normal;
      font-family: "Open Sans";
    }

    .steps {
      display: flex;
      flex-direction: column;
      gap: .2rem;
    }
  }
`;